import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import { styled, View, fromTheme, ThemeComponentSwitcher } from 'lib_ui-primitives';
import TabCarousel from './TabCarousel';
import TabCarouselGL2025 from './TabCarousel.gl2025';
import Selection from './Selection';
import TabPanels from './TabPanels';

const _Tabs = styled(View).attrs({ name: 'tabs', role: 'tablist' })`
    flex-grow: 1;
    flex-basis: 1px;
    flex-direction: column;
    background-color: ${fromTheme('tabs', 'container', 'backgroundColor')};
`;

// Theme-aware TabCarousel switcher: old (arrow buttons) vs GL2025 (smooth scroll + gradients)
const TabCarouselSwitcher = ThemeComponentSwitcher([
    { theme: 'gl2025', component: TabCarouselGL2025 },
    { theme: 'old', component: TabCarousel }
]);

/**
 * @typedef {Object} Props
 * @property {Object} hNode
 * @property {string} currentRoute
 * @property {import('react').ReactNode} [children]
 */
function Tabs({
    children,
    hNode: { children: childrenHNodes = [], id } = { children: [] }
} = { children: [], hNode: { children: [] } }) {

    // prettier-ignore
    return rc(Selection, { numTabs: childrenHNodes.length },
        rc(_Tabs, { id, name: 'tabs' },
            rc(TabCarouselSwitcher, { id, childrenHNodes }),
            rc(TabPanels, { id, childrenHNodes }, children)
        )
    );
}

Tabs.propTypes = {
    hNode: PropTypes.shape({
        id: PropTypes.string,
        children: PropTypes.array
    }).isRequired,
    children: PropTypes.node,
    currentRoute: PropTypes.string
};

export default Tabs;
